// extracted by mini-css-extract-plugin
export default {"statusBadge":"_2-CpM8Hb","statusActive":"_18Y1nUg0","statusPending":"KkQTKG7S","statusClosed":"p7AAseJR"};